import React, { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";

type NpcIndicator =
  | "none"
  | "information"
  | "quest"
  | "quest_complete"
  | "vendor"
  | "crafting"
  | "bank"
  | "pawnbroker"
  | "auction_house"
  | "side_quest_available"
  | "side_quest_unavailable"
  | "side_quest_complete"
  | "side_quest_incomplete"
  | "main_quest_available"
  | "main_quest_unavailable"
  | "main_quest_complete"
  | "main_quest_incomplete"
  | "tutorial_quest_available"
  | "tutorial_quest_unavailable"
  | "tutorial_quest_complete"
  | "tutorial_quest_incomplete";

const npcIndicators: Record<NpcIndicator, string> = {
  none: "none",
  information: "information",
  quest: "quest",
  quest_complete: "quest complete",
  vendor: "vendor",
  crafting: "crafting",
  bank: "bank",
  pawnbroker: "pawnbroker",
  auction_house: "auction_house",
  side_quest_available: "Side Quest Available",
  side_quest_unavailable: "Side Quest Unavailable",
  side_quest_complete: "Side Quest Complete",
  side_quest_incomplete: "Side Quest Incomplete",
  main_quest_available: "Main Quest Available",
  main_quest_unavailable: "Main Quest Unavailable",
  main_quest_complete: "Main Quest Complete",
  main_quest_incomplete: "Main Quest Incomplete",
  tutorial_quest_available: "Tutorial Quest Available",
  tutorial_quest_unavailable: "Tutorial Quest Unavailable",
  tutorial_quest_complete: "Tutorial Quest Complete",
  tutorial_quest_incomplete: "Tutorial Quest Incomplete",
};

interface SelectNpcIndicatorProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
  showLabel?: boolean;
}

const SelectNpcIndicator: React.FC<SelectNpcIndicatorProps> = ({
  color,
  value,
  setValue,
  showLabel,
  ...chakraProps
}) => {
  const handleSearch = useCallback(async (searchQuery?: string): Promise<[string, string][]> => {
    return Object.entries(npcIndicators)
      .filter(([_, displayName]) =>
        searchQuery ? displayName.toLowerCase().includes(searchQuery.toLowerCase().trim()) : true
      )
      .sort(([_, a], [__, b]) => a.localeCompare(b));
  }, []);

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"NPC Indicator"}
        showLabel={showLabel}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectNpcIndicator;
